import type { TaskDueFilter } from '@src/features/tasks/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PanelFilter from './PanelFilter';

type TasksFilterProps = {
  value: TaskDueFilter;
  onChange: (value: TaskDueFilter) => void;
};

export default function TasksFilter({ value, onChange }: TasksFilterProps) {
  const { t } = useTranslation();

  // Overdue leads because it is what the panel opens on; "All" sits last as
  // the way back to the unnarrowed list the panel used to show.
  const options = useMemo(
    () => [
      {
        label: t('tasks.filter_overdue', 'Overdue'),
        value: 'overdue' as const,
      },
      {
        label: t('tasks.filter_upcoming', 'Upcoming'),
        value: 'upcoming' as const,
      },
      { label: t('common.all', 'All'), value: 'all' as const },
    ],
    [t],
  );

  return (
    <PanelFilter
      label={t('tasks.filter_label', 'Task filter')}
      value={value}
      options={options}
      fallback="all"
      onChange={onChange}
    />
  );
}
